import * as tslib_1 from "tslib";
import { QueryParams } from '@ml/shared/types/query-params';
var TaskQueryParams = /** @class */ (function (_super) {
    tslib_1.__extends(TaskQueryParams, _super);
    function TaskQueryParams() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TaskQueryParams;
}(QueryParams));
export { TaskQueryParams };
